import { takeLatest, put, call, fork } from 'redux-saga/effects';
import callApi from 'utils/api';
import * as types from './direct-routes-handler-constants';
import * as actions from './direct-routes-handler-actions';

export function* doGetRedirectInfo(action) {
  try {
    const { type, queryString } = action.payload;
    const results = yield call(callApi, {
      endpoint: `search/direct/${type}${queryString}`,
      options: {
        errorMessage: 'Could not get draft data',
        retryAction: action,
      },
    });
    yield put(actions.getRedirectInfoSuccess(results));
  } catch (err) {
    yield put(actions.getRedirectInfoFailure(err));
  }
}

function* watchGetRedirectInfo() {
  yield takeLatest(types.GET_REDIRECT_INFO_REQUEST, doGetRedirectInfo);
}


export default [fork(watchGetRedirectInfo)];
